import { AIExtractionEventPayload } from '../../../ai/ai.process.inbox';
import { AIBillImportSetting, AIEffectiveSettings, AIGeneralSetting, AITaskValidationSetting, WorkbuddyAgentConfigs } from '../../settings/ai.settings';
import { SocketRoomEvent } from '../tenant.notification.payload';
import { RoomKey } from '../socket.room.key';

export const AISettingsEventType = {
    GeneralUpdated: 'ai-settings:general-updated',
    TaskValidationUpdated: 'ai-settings:task-validation-updated',
    BillImportUpdated: 'ai-settings:bill-import-updated',
    WorkbuddyAgentUpdated: 'ai-settings:workbuddy-agent-updated',
    EffectiveUpdated: 'ai-settings:effective-updated',
} as const;

export const AIExtractionEventType = {
    Processing: 'extraction:processing',
    Completed: 'extraction:completed',
} as const;

export type AIEffectiveSettingsMessage = SocketRoomEvent<typeof AISettingsEventType.EffectiveUpdated, AIEffectiveSettings>;

export type AISettingsRoomMessage =
    | SocketRoomEvent<typeof AISettingsEventType.GeneralUpdated, AIGeneralSetting>
    | SocketRoomEvent<typeof AISettingsEventType.TaskValidationUpdated, AITaskValidationSetting>
    | SocketRoomEvent<typeof AISettingsEventType.BillImportUpdated, AIBillImportSetting>
    | SocketRoomEvent<typeof AISettingsEventType.WorkbuddyAgentUpdated, WorkbuddyAgentConfigs>;

export type AIExtractionRoomMessage =
    | SocketRoomEvent<typeof AIExtractionEventType.Processing, AIExtractionEventPayload>
    | SocketRoomEvent<typeof AIExtractionEventType.Completed, AIExtractionEventPayload>;

export const AIRooms = {
    aiSettings: (): RoomKey<AISettingsRoomMessage> => ({ key: 'ai-settings' }),
    aiExtraction: (parentId: string, entity: string): RoomKey<AIExtractionRoomMessage> => ({ key: `ai-extraction:${parentId}:${entity}` }),
};
